// Single source of truth for the StudentPortal's localStorage keys, so they
// can't drift out of sync between the files that read/write them
// (studentApi.js, StudentSessionContext.js, StudentProtectedRoute.js,
// StudentLogin.js, StudentHeader.js).
export const STUDENT_STORAGE_KEYS = {
  TOKEN: "studentToken",
  USER: "studentUser",
  ID: "studentId",
  ORGANIZATION_ID: "studentOrganizationId",
  SESSION_ID: "studentSessionId",
  ACTIVE_CHILD_ID: "studentPortal.activeChildId",
  SIDEBAR_COLLAPSED: "studentPortal.sidebarCollapsed",
};
